import { Pipe, PipeTransform, inject } from "@angular/core";
import { TvpiIrrFormatService } from "../services/tvpi-irr-format.service";
@Pipe({
    name: 'irrValueFormat'
})

export class IrrValueFormatPipe implements PipeTransform {
    private irrFormat = inject(TvpiIrrFormatService);


    transform(value: number | null | undefined): string {
        return this.irrFormat.getIrrValue(value);
    }
}
